import { render, staticRenderFns } from "./search-menu-item.vue?vue&type=template&id=af960f9a"
import script from "./search-menu-item.vue?vue&type=script&lang=js"
export * from "./search-menu-item.vue?vue&type=script&lang=js"
import style0 from "./search-menu-item.vue?vue&type=style&index=0&id=af960f9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports